import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { OkAloneService } from 'src/app/ok-alone.service';
import Utils from 'src/app/utils';

import * as _ from 'lodash-es';
declare var require: any;


@Component({
  selector: 'app-workers-upload',
  templateUrl: './workers-upload.component.html',
  styleUrls: ['./workers-upload.component.scss']
})
export class WorkersUploadComponent implements OnInit {

  u = Utils;

  falseVal = false;



  uploader:FileUploader;
  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;
  response:string;

  workers:any = null;
  workers2:any = null;

  step = 1;

  upload_errors = false;

  file_error = "";

  extra_fields = ['','','','','']

  extra_field_options = [
    {field:"",name:"Choose Field"},
    {field:"information",name:"Information"},
    {field:"cell",name:"Alt Phone"},
    {field:"spot",name:"Spot Code"},
    {field:"timezone",name:"Timezone Code"},
    {field:"country",name:"Country Code"},
    {field:"zoleo_imei",name:"ZOLEO IMEI"},
    {field:"zoleo_number",name:"ZOLEO Phone"},
    {field:"geotab",name:"Geotab ID"},
  ];

  extra_field_valid = true;

  welcome_loading = false;

  constructor (public okService:OkAloneService){


    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    let url = this.okService.getUrl('workers/upload');
    this.uploader = new FileUploader({url: url});

    this.response = '';

    this.setupLoader();
  }

  setupLoader(){

    let url = this.okService.getUrl('workers/upload');
    //console.log(url);

    let token = "Bearer "+this.okService.session.token;
    //console.log(token);

    let headers: { name: string; value: string }[] = [];
    if (this.okService.session.cid) {
      headers.push({ name: 'cid', value: this.okService.session.cid });
    }

    this.uploader = new FileUploader({
      url: url,
      authToken: token,
      headers: headers,
      itemAlias:"upload",
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      // formatDataFunctionIsAsync: true,
      // formatDataFunction: async (item:any) => {
      //   return new Promise( (resolve, reject) => {
      //     resolve({
      //       name: item._file.name,
      //       length: item._file.size,
      //       contentType: item._file.type,
      //       date: new Date()
      //     });
      //   });
      //}
    });

    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });

    this.uploader.response.subscribe( res => {

      this.file_error = "";

      let data = JSON.parse(res);
      //console.log(data);

      if(data['error']){
        this.file_error = data['error'];
      }else{

      this.upload_errors = false;
      this.workers = JSON.parse(res);
      //console.log('uploader',this.workers);

      let self = this;
      _.forEach(this.workers, function(worker:any) {
        if(worker.errors.length > 0){
          self.upload_errors = true;
        }

      });

      // Check workers for errors
      this.step =2;
      }


    } );


  }



  uploadWorkers(){
    //'pre-upload',this.workers);

    //console.log(this.extra_fields);

    this.extra_field_valid = true;

    if(this.workers[0].extra_field_1){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[0]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.workers[0].extra_field_2){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[1]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.workers[0].extra_field_3){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[2]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.workers[0].extra_field_4){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[3]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.workers[0].extra_field_5){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[4]!=''
        //console.log(this.extra_field_valid);
    }
    //console.log(this.extra_field_valid);

    if(this.extra_field_valid){


      this.okService.post("workers/upload",{"workers":this.workers,"extra_fields":this.extra_fields})
      .subscribe({
        next: (data) => {
          this.workers2 = data.body;
          this.step = 3;
        },
        error: (e) => {
          this.file_error = e?.message || 'This upload would exceed your Worker Licenses.';
        }
      });
    }
  }

  ngOnInit(): void {
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }

  reset(){
    this.upload_errors = false;
    this.file_error = "";
    this.workers = null;
    this.setupLoader();
    this.step = 1;
  }

  sendWelcome(){

    this.welcome_loading = true;

    let ids:any = [];
    _.forEach(this.workers2, function(workers:any) {
      ids.push(workers.id)
    });
    //console.log(ids);



    this.okService.post("workers/welcomes",{"ids":ids})
    .subscribe((data) => {

      this.okService.setAlert("The worker welcome email/SMS has been sent","success")

      this.welcome_loading = false;

    });


  }

}
